module.exports = __webpack_public_path__ + "img/logo.3283d951.png";